const LandingPage = () => {

    return (
        <div>
            <div className='center-div center-div-vert' style={{userSelect: 'none'}} >
                <img src='demo_logo.png' style={{width: '90%'}} alt=''></img>
            </div>
        </div>
    );
}

export default LandingPage;
